<template>
  <vgloballayout :loading="loadingPage" :error="error" @reload="aboutGet">
    <div slot="body">
      <h1>Страница "О нас"</h1>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <el-form-item prop="value" class="form-html">
          <textarea
            id="editornew"
            multiple=""
            ref="editornew"
            name="editor"
          ></textarea>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="imageDelete()" :loading="loading"
            >Сохранить</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </vgloballayout>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { BASE_URL, BASE_DOC_URL } from "@/plugins/url-env";

export default {
  data() {
    return {
      content: "",
      contentTemp: "", //сохраняем первичное состояние контента для поиска удаленных картинок
      loading: false,
      loadingPage: false,
      error: false,
      ruleForm: {
        value: ""
      },
      editor: null,
      rules: {
        content: [
          {
            required: true,
            message: "Поле не должно быть пустым",
            trigger: "blur"
          },
          {
            min: 0,
            max: 10000,
            message: "Максимум 10000 символов",
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {
    this.aboutGet();
  },

  computed: {},
  methods: {
    async initializationEditor() {
      setTimeout(() => {
        var editor = new Jodit(this.$refs.editornew, {
          uploader: {
            url: BASE_URL + "/LocalStorage/Upload",
            format: "json",
            filesVariableName: "File",
            pathVariableName: "File",
            withCredentials: true,
            prepareData: function(data) {
              data.append("file", data.get("files[0]"));
              data.delete("files[0]");
              data.delete("path");
              data.delete("source");
            },
            isSuccess: function(resp) {
              if (window.getSelection) {
                var elem = document.createElement("img");
                const src = `${BASE_URL}/${resp.file}`;
                elem.src = src;
                var wall = window.getSelection().focusNode.parentNode.firstChild
                  .parentNode;
                //проверяем где расположена каретка. Если вне редактора тогда вставляем картинку начало
                if (
                  window
                    .getSelection()
                    .focusNode.parentNode.firstChild.parentNode.closest(
                      ".jodit_wysiwyg"
                    ) !== null
                ) {
                  var first = wall.childNodes[0];
                  wall.insertBefore(elem, first);
                } else {
                  editor.value = `<img src="${src}" />` + editor.value;
                }
              } else if (document.selection && document.selection.createRange) {
                document.selection.createRange().text = respImg;
              }

              return !resp.error;
            },
            getMsg: function(resp) {
              return resp.msg.join !== undefined
                ? resp.msg.join(" ")
                : resp.msg;
            },
            process: function(resp) {
              return {
                baseurl: resp.baseurl,
                error: resp.error,
                msg: resp.msg
              };
            },
            error: function(e) {
              this.$notify.error({
                title: "Произошла ошибка",
                message: `Что-то пошло не так, обратитесь в техподдержку`,
                offset: 0
              });
            },
            defaultHandlerSuccess: function(data, resp) {
              var i,
                field = "files";
              if (data[field] && data[field].length) {
                for (i = 0; i < data[field].length; i += 1) {
                  this.selection.insertImage(data.baseurl + data[field][i]);
                }
              }
            },

            defaultHandlerError: function(resp) {
              console.log("err => ", resp);
            }
          },
          language: "ru",
          minHeight: 400,
          editSrc: true,
          showPreview: true
        });
        editor.value = this.content;

        editor.events.on("change", data => {
          this.content = data;
        });

        this.editor = editor;
      }, 400);
    },

    async aboutGet() {
      this.loadingPage = true;
      this.error = false;

      try {
        this.content = await this.$store.dispatch("aboutGet", 1);
        this.contentTemp = this.content;
        this.initializationEditor();
      } catch (e) {
        this.error = this.$ErrorsMod(e);
      }

      this.loadingPage = false;
    },

    async imageDelete() {
      // Если текст в стейте content не такой же, как в editor, перезаписываем его
      if (this.content !== this.editor.value) {
        this.content = this.editor.value;
      }

      let divOld = document.createElement("div");
      divOld.innerHTML = this.contentTemp;

      let divNew = document.createElement("div");
      divNew.innerHTML = this.content;

      //забираем картинки
      let arrImgNew = divNew.getElementsByTagName("img");
      let arrImgOld = divOld.getElementsByTagName("img");

      let arrLinkNew = [];
      let arrLinkOld = [];

      //получаем только ссылки
      for (let i = 0; i < arrImgNew.length; i++) {
        arrLinkNew.push(arrImgNew[i].src);
      }

      //получаем только ссылки
      for (let i = 0; i < arrImgOld.length; i++) {
        arrLinkOld.push(arrImgOld[i].src);
      }

      let concatArray = arrLinkOld.concat(arrLinkNew);

      let uniqueItems = arrLinkOld.filter(n => arrLinkNew.indexOf(n) === -1);

      if (uniqueItems.length > 0) this.handleImageRemoved(uniqueItems);
      this.submitForm();
    },

    async submitForm() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          this.loading = true;

          let content = {
            text: this.content.replace(/'/g, "&apos;"),
            pageType: 1
          };
          try {
            await this.$store.dispatch("aboutCreateOrUpdate", content);
            this.$message({
              message: "Сохранено",
              type: "success"
            });
          } catch (e) {
            this.$ErrorsMod(e);
          }

          this.loading = false;
        } else {
          return false;
        }
      });
    },

    async handleImageRemoved(image) {
      let arrayIdImg = [];

      image.forEach(element => {
        let temLink = element.split("/");
        temLink[image.length - 1];
        arrayIdImg.push(temLink[temLink.length - 1]);
      });

      try {
        await this.$store.dispatch("documentDeleteFiles", arrayIdImg);
      } catch (e) {
        this.$ErrorsMod(e);
      }
    }
  },
  components: {}
};
</script>

<style>
.form-html .el-form-item__content {
  line-height: 20px !important;
}
</style>
